"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateQuickAmountsSettings = void 0;
const react_1 = require("react");
const api_1 = require("./api");
const utils_1 = require("../../utils");
const errors_1 = require("../../utils/errors");
const useUpdateQuickAmountsSettings = () => {
    const { data } = (0, api_1.useGetProfileSettings)();
    const [updateProfileSettings, { isLoading, error }] = (0, api_1.useUpdateProfileSettings)();
    const profileSettings = (0, react_1.useMemo)(() => {
        var _a;
        const parsedSettings = (0, utils_1.jsonParse)((_a = data === null || data === void 0 ? void 0 : data.settings) !== null && _a !== void 0 ? _a : '', {});
        if (parsedSettings === null || parsedSettings === void 0 ? void 0 : parsedSettings.quickAmountsSettings) {
            return '';
        }
        return data === null || data === void 0 ? void 0 : data.settings;
    }, [data === null || data === void 0 ? void 0 : data.settings]);
    const updateQuickAmountsSettings = (0, react_1.useCallback)(async (quickAmounts) => {
        await updateProfileSettings({
            settings: profileSettings,
            quickAmounts,
        });
    }, [profileSettings, updateProfileSettings]);
    return (0, react_1.useMemo)(() => ({
        updateQuickAmountsSettings,
        isLoading,
        error: error !== undefined ? (0, errors_1.getErrorOrUnknown)(error) : null,
    }), [updateQuickAmountsSettings, isLoading, error]);
};
exports.useUpdateQuickAmountsSettings = useUpdateQuickAmountsSettings;
//# sourceMappingURL=useUpdateQuickAmountsSettings.js.map